import FaqAccordion from "@/components/feature/FaqAccordion";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  return (
    <section id="faq" className="w-full px-4 md:px-8 py-14 md:py-20">
      <SectionHeading
        eyebrow="FAQ"
        title="关于独家黑料与证据链，你可能想问"
        desc="围观之前，先看看这些常见问题。如果你有更具体的疑问，也可以通过下方的线索投递入口联系我们。"
      />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-8">
          <FaqAccordion items={faqs} />
        </div>
        <aside className="lg:col-span-4 rounded-lg border border-accent-200 bg-accent-50 p-6 flex flex-col">
          <span className="flex w-11 h-11 items-center justify-center rounded-md bg-accent-500 text-primary-950">
            <i className="ri-lightbulb-flash-line text-xl" />
          </span>
          <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">还没找到答案？</h3>
          <p className="mt-2.5 text-sm leading-relaxed text-foreground-700 flex-1">
            无论是内容更正、材料补充，还是想指出我们整理中的疏漏，都欢迎直接投递。核对后会同步到对应档案。
          </p>
          <a
            href="#tips"
            className="mt-6 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm font-medium whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
          >
            前往线索投递
            <i className="ri-arrow-down-line" />
          </a>
        </aside>
      </div>
    </section>
  );
}